'use-client';
import React from 'react';
import type { IStylableButtonImperativeActions } from '../../../../../StylableButton/StylableButton.types';
import type { ISlideshowButtonProps } from '../../../../types';
import SlideshowButtonCommon from '../../SlideshowButtonCommon';
import StylableButton from '../../../../../StylableButton/viewer/skinComps/StylableButton/StylableButton.skin';

const SlideshowButton: React.ForwardRefRenderFunction<
  IStylableButtonImperativeActions,
  ISlideshowButtonProps
> = (props, ref) => {
  return (
    <SlideshowButtonCommon
      {...props}
      ref={ref}
      StylableButtonComponent={StylableButton}
    />
  );
};

export default React.forwardRef(SlideshowButton);
